/** Thông tin người dùng hub (quyền admin, hạn mức). Nhiều component cùng trang dùng chung một lần gọi `/me`
 *  (cache 60 giây) — quyền không lệch giữa các phần và trang không chớp sang tab khác khi chưa tải xong. */
import { useEffect, useState } from 'react';
import { aiAgentApi } from '@/services/knowledge/ai-agent-api';
import type { AiHubMe } from '@/types/ai-agent';

type MeResult = { me: AiHubMe | null; error: string | null };

const TTL_MS = 60_000;
let shared: { at: number; promise: Promise<MeResult> } | null = null;

const loadMe = (): Promise<MeResult> => {
  if (shared && Date.now() - shared.at < TTL_MS) return shared.promise;
  const promise = aiAgentApi
    .me()
    .then((res): MeResult => (res?.success ? { me: res.data, error: null } : { me: null, error: res?.message || 'Không kết nối được AI Agent Hub' }))
    .catch((e: unknown): MeResult => ({ me: null, error: e instanceof Error ? e.message : 'Không kết nối được AI Agent Hub' }));
  shared = { at: Date.now(), promise };
  // Lỗi không giữ trong cache — lần sau gọi lại
  void promise.then((r) => {
    if (r.error && shared?.promise === promise) shared = null;
  });
  return promise;
};

export const useAiHubMe = () => {
  const [me, setMe] = useState<AiHubMe | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void loadMe().then((r) => {
      if (cancelled) return;
      setMe(r.me);
      setError(r.error);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { me, loading, error };
};
